export default {
  // DepartmentInformation
  departmentName: 'Department Name',
  departmentCode: 'Department Code',
  temporary: 'Temporary Area',
  state: 'Application Status',
  departmentAdd: 'Add Department',
  selectDelete: 'Delete Selected',
  modifyBtn: 'Edit',
  title: 'Add Department',
  title2: 'Delete Department Info',
  updateTitle: 'Edit Department',
  deleteMsg: 'Do you want to delete the selected item(s)?',
  alertMsg: 'Please select an item to delete.',
  modificationDate: 'Last Edited Date & Time',
  createMsg: 'Department information has been registered.',
  updateMsg: 'Department information has been updated.',
  deleteMessage: 'Department information has been deleted.',
  validationContentNull: 'Please enter department information.',
  validationContentLength: 'Department information must be 100 characters or fewer.',
};
